module.exports = __webpack_public_path__ + "static/media/note-regular-white.51e38f49.svg";